<template>
	<div>
		<Camera
			v-if="showCamera"
			@close-camera="closeCamera"
			@image-taken="(imageString) => loadImageAbastecimento(imageString)"
		/>
		<Camera
			v-if="showCameraAnexos"
			@close-camera="closeCameraAnexos"
			@image-taken="(imageString) => loadImageAnexos(imageString)"
		/>
		<div v-for="(item, index) in form" :key="item.id">
			<div class="row" v-if="permitirExcluir">
				<div class="col-xs-12" style="margin: 0">
					<button
						class="btn btn-danger pull-right"
						@click="clickExcluirAbastecimento(item, index)"
						style="font-size: 14px"
						v-tooltip="_traducao('global', 'excluir')"
					>
						<i class="fa fa-fw fa-trash" />
					</button>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12 col-sm-3 form-group"
					:class="{'has-error': item.erro.numero_ce != null}"
				>
					<label>* {{ _traducao('global', 'numeroDeCE') }}:</label>
					<input v-model="item.numero_ce" class="form-control" />
					<p class="help-block" v-if="item.erro.numero_ce != null">
						{{ item.erro.numero_ce }}
					</p>
				</div>
				<div
					class="col-xs-12 col-sm-3 form-group"
					:class="{'has-error': item.erro.id_tipo_lancamento != null}"
				>
					<label>* {{ _traducao('global', 'tipoMovimentacao') }}:</label>
					<div style="display: flex">
						<select class="form-control" v-model="item.id_tipo_lancamento">
							<option
								v-for="movimentacao in tipoMovimentacoes"
								:key="movimentacao.id"
								:value="movimentacao.id"
							>
								{{ movimentacao.descricao }}
							</option>
						</select>
					</div>
					<p class="help-block" v-if="item.erro.id_tipo_lancamento != null">
						{{ item.erro.id_tipo_lancamento }}
					</p>
				</div>
				<div
					class="col-sm-3 form-group"
					:class="{'has-error': item.erro.designativo_abastecimento != null}"
				>
					<label
						>{{ _traducao('global', 'aerodromoLocalAbastecimento') }}:</label
					>
					<select
						class="form-control"
						v-model="item.designativo_abastecimento"
						@change="
							alteraDataAbastecimento(item.designativo_abastecimento, index)
						"
					>
						<option value="origem">
							{{ _traducao('global', 'origem') }}
						</option>
						<option value="destino">
							{{ _traducao('global', 'destino') }}
						</option>
					</select>
					<p
						class="help-block"
						v-if="item.erro.designativo_abastecimento != null"
					>
						{{ item.erro.designativo_abastecimento }}
					</p>
				</div>
			</div>
			<aua
				ref="movimentacaoAuaRef"
				v-if="item.id_tipo_lancamento == 6"
				:aeronave="aeronave"
				:campo-orgao="campoOrgao"
				:movimentacao="item"
				:orgaos="orgaos"
				:unidades-armazenamento="unidadesArmazenamento"
				:unidade-armazenamento-selecionada="
					item.unidadeArmazenamentoSelecionada
				"
				@abastecimento-aua-valido="dadosAbastecimentoValido"
				@abastecimento-aua-invalido="dadosAbastecimentoInvalido"
				@seleciona-unidade-armazenamento="
					selecionaUnidadeArmazenamento(index, $event)
				"
			/>
			<avc
				ref="movimentacaoAvcRef"
				v-if="item.id_tipo_lancamento == 10"
				:aeronave="aeronave"
				:campo-orgao="campoOrgao"
				:fornecedores="fornecedores"
				:movimentacao="item"
				:orgaos="orgaos"
				@abastecimento-avc-valido="dadosAbastecimentoValido"
				@abastecimento-avc-invalido="dadosAbastecimentoInvalido"
				@carrega-contratos="carregaContratos(index, $event)"
				@carrega-empenhos="carregaEmpenho(index, $event)"
				@preencher-orgao="preenhcerOrgao(index, $event)"
			/>
			<div class="row">
				<div class="col-sm-6">
					<div class="" style="margin-top: 9px">
						<flUploadFile
							name="anexos"
							:id-input="index"
							:excluir-u-r-l="true"
							:excluir-adicionados="true"
							:excluir-por-id="true"
							:habilita-excluir="true"
							:url-excluir="urlExcluir"
							ref="anexos"
							@upload-file="(files) => uploadFiles(index, files)"
							:url="urlEnvio"
							ext="jpg|jpeg|png|pdf|doc|docx|xls|xlsx"
						/>
					</div>
				</div>
				<div v-if="_isMobile" class="col-sm-6">
					<ButtonNew size="lg" @click="openCamera(index)">Tirar Foto</ButtonNew>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-xs-12" style="margin-top: 10px">
				<button
					class="btn btn-info btn-sm"
					type="button"
					@click="clickAddAbastecimento()"
				>
					<i class="fa fa-fw fa-plus"></i
					>{{ _traducao('global', 'adicionarAbastecimento').toUpperCase() }}
				</button>
			</div>
		</div>
		<movimentacoes-combustivel
			ref="movimentacoesCombustivel"
			@selecionou-movimentacao="(data) => movimentacaoSelecionado(data)"
		/>
	</div>
</template>

<script>
import Camera from '@/modules/componentsv2/camera/main.vue'
import mixinsAbastecimento from './mixinsAbastecimento.js'
import movimentacoesCombustivel from '../informacoes-movimentacoes-combustivel.vue'
import aua from './movimentacoes/aua.vue'
import avc from './movimentacoes/avc.vue'
export default {
	name: 'ComponenteMovimentacaoAbastecimento',
	mixins: [mixinsAbastecimento],
	components: {
		Camera,
		movimentacoesCombustivel,
		aua,
		avc
	},
	props: {
		dadosAbastecimento: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		aeronave: {
			default() {
				return {}
			},
			type: Object,
			required: true
		},
		trecho: {
			default() {
				return {}
			},
			type: Object,
			required: true
		},
		unidadesArmazenamento: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		fornecedores: {
			default() {
				return []
			},
			type: Array,
			required: true
		},
		permitirExcluir: {
			default: true,
			required: true,
			type: Boolean
		}
	},
	data() {
		return {
			tipoMovimentacoes: [],
			form: [],
			campoOrgao: null,
			orgaos: [],
			validadorComponenteAbastecimentoMovimentacao: false,
			abastecimentoIndex: 0,
			showCamera: false,
			showCameraAnexos: false,
			urlEnvio: this.getURL_WS('/Utilitarios/recebe_arquivo'),
			urlExcluir: 'mg-siga/Relatorio_voo_trecho/excluir_anexo_abastecimento',
			urlExcluirAnexo: 'mg-siga/Relatorio_voo_trecho/excluir_anexo',
		}
	},
	watch: {
		dadosAbastecimento: {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.form = this.dadosAbastecimento
				}
			}
		}
	},	
	methods: {
		async validadorFormAbastecimento() {
			if (await this.validarComponenteAbastecimento()) {
				this.$emit('abastecimento-valido', this.form)
			} else {
				this.$emit('abastecimento-invalido', false)
			}
		},

		selecionaUnidadeArmazenamento(index, id) {
			this.$emit('seleciona-unidade-armazenamento', id, index)
		},

		carregaContratos(index, id) {
			this.$emit('carrega-contratos', id, index)
		},

		carregaEmpenho(index, id) {
			this.$emit('carrega-empenhos', id, index)
		},
		preenhcerOrgao(index, id) {
			this.$emit('preenhcer-Orgao', id, index)
		},
		dadosAbastecimentoValido(form, index) {
			this.validadorComponenteAbastecimentoMovimentacao = true
			this.form[index] = form
		},
		dadosAbastecimentoInvalido(errors) {
			this.validadorComponenteAbastecimentoMovimentacao = false
		},

		async validarComponenteAbastecimento() {
			var passou = true
			var obrigatorio = this._traducao('global', 'obrigacao')

			const qtd_abastecimento = this.form.length
			let auaIndex = 0
			let avcIndex = 0
			for (
				let abastecimento = 0;
				abastecimento < qtd_abastecimento;
				abastecimento++
			) {
				if (this.form[abastecimento].numero_ce == null) {
					this.form[abastecimento].erro.numero_ce = obrigatorio
					passou = false
				} else {
					this.form[abastecimento].erro.numero_ce = null
				}
				if (this.form[abastecimento].id_tipo_lancamento == null) {
					this.form[abastecimento].erro.id_tipo_lancamento = obrigatorio
					passou = false
				} else {
					this.form[abastecimento].erro.id_tipo_lancamento = null
					switch (this.form[abastecimento].id_tipo_lancamento) {
					case '6':
						await this.$refs.movimentacaoAuaRef[
							auaIndex
						].validadorFormAbastecimentoAua(abastecimento)
						auaIndex++
						break
					case '10':
						await this.$refs.movimentacaoAvcRef[
							avcIndex
						].validadorFormAbastecimentoAvc(abastecimento)
						avcIndex++
						break
					default:
						this.validadorComponenteAbastecimentoMovimentacao = true
					}
					if (!this.validadorComponenteAbastecimentoMovimentacao) {
						passou = this.validadorComponenteAbastecimentoMovimentacao
					}
				}
			}

			return passou
		},

		async getTipoMovimentacoes() {
			this._axios('/Tipo_lancamento/get_movimentacoes_db', 'get', {
				callback: (response) => {
					if (response._status && response._request) {
						this.tipoMovimentacoes = response.lista
					}
				}
			})
		},
		getParametros() {
			this._getParametro(61).then((valor) => (this.campoOrgao = valor))
		},
		getOrgaos() {
			this._axios('/Orgao/get_orgao', 'get', {
				callback: (response) => {
					if (response._status && response._request) {
						this.orgaos = response.lista.map((orgao) => ({
							...orgao,
							label: orgao.descricao,
							value: orgao.id
						}))
					}
				}
			})
		},

		carregaListaAnexo(anexosMovimentacao, index){
			if (this.$refs.anexos) {
				this.$refs.anexos[index].carregaLista(anexosMovimentacao)
			}
		},
	},
	

	async created() {
		await this.getTipoMovimentacoes()
		this.getParametros()
		this.getOrgaos()
	}
}
</script>

<style scoped></style>